var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmPopup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60 17.69C48.7787 17.69 38.017 22.1476 30.0823 30.0823C22.1476 38.017 17.69 48.7787 17.69 60C17.69 71.2213 22.1476 81.983 30.0823 89.9177C38.017 97.8524 48.7787 102.31 60 102.31C71.2213 102.31 81.983 97.8524 89.9177 89.9177C97.8524 81.983 102.31 71.2213 102.31 60C102.31 48.7787 97.8524 38.017 89.9177 30.0823C81.983 22.1476 71.2213 17.69 60 17.69ZM10 60C10 32.385 32.385 10 60 10C87.615 10 110 32.385 110 60C110 87.615 87.615 110 60 110C32.385 110 10 87.615 10 60Z",
    fill: "#D93131"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.0004 38.2051C61.0215 38.2051 62.0007 38.6107 62.7228 39.3327C63.4448 40.0547 63.8504 41.034 63.8504 42.0551V62.5651C63.8504 63.5862 63.4448 64.5654 62.7228 65.2874C62.0007 66.0095 61.0215 66.4151 60.0004 66.4151C58.9793 66.4151 58 66.0095 57.278 65.2874C56.556 64.5654 56.1504 63.5862 56.1504 62.5651V42.0501C56.1517 41.0299 56.5579 40.0519 57.2798 39.331C58.0017 38.61 58.9802 38.2051 60.0004 38.2051Z",
    fill: "#D93131"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1301 77.9501C65.1301 78.6237 64.9974 79.2908 64.7396 79.9132C64.4818 80.5356 64.1039 81.1012 63.6276 81.5775C63.1512 82.0539 62.5857 82.4318 61.9633 82.6896C61.3409 82.9474 60.6738 83.0801 60.0001 83.0801C59.3264 83.0801 58.6594 82.9474 58.037 82.6896C57.4145 82.4318 56.849 82.0539 56.3727 81.5775C55.8963 81.1012 55.5184 80.5356 55.2606 79.9132C55.0028 79.2908 54.8701 78.6237 54.8701 77.9501C54.8701 76.5895 55.4106 75.2847 56.3727 74.3226C57.3347 73.3605 58.6396 72.8201 60.0001 72.8201C61.3607 72.8201 62.6655 73.3605 63.6276 74.3226C64.5896 75.2847 65.1301 76.5895 65.1301 77.9501Z",
    fill: "#D93131"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmPopup);
export default __webpack_public_path__ + "static/media/confirm-popup.d238f6c7b64ad6b1af5d56986ce5fcc8.svg";
export { ForwardRef as ReactComponent };